import { jsx as a, Fragment as C, jsxs as s } from "react/jsx-runtime";
import e from "./styles.module.less.js";
import y from "./logo.webp.js";
import A from "./menu-dropdown-wrapper-mobile.svg.js";
import S from "./burger.svg.js";
import G from "./close.svg2.js";
import { useState as w, useCallback as d, useMemo as H } from "react";
import { AccountLink as x } from "./account-link/index.js";
import v from "./chevron-right.svg.js";
import { DropdownMenuItemMobile as D } from "./dropdown-menu-item/index.js";
import { useDisableScroll as R } from "../../../utils/use-disable-scroll.js";
import { areasOfLawData as T } from "../../../constants.js";
import { convertToKebabCase as q } from "../../../utils/case-conversion.js";
import { MobileAccountModalLink as B } from "./mobile-account-modal/index.js";
import { ForLawyersMenuButtonMobile as W } from "./for-lawyers-button/index.js";
import { GetHelpMenuItemMobile as O } from "./get-help-menu-item/index.js";
import { GradientButton as j } from "./gradient-button/index.js";
import { MenuChatButtonMobile as E } from "./chat-button/index.js";
import F from "./chevron-right-gradient.svg.js";
const ue = (t) => {
  const {
    isAuthenticated: u,
    openAuthModal: n,
    getTranslation: l,
    language: p,
    useWill: o,
    lmpEnabled: f,
    onRequestLawyer: h,
    hideLinks: M
  } = t, [r, i] = w(!1);
  R({ isDisabled: r });
  const c = d(() => {
    i(!0);
  }, []), b = d(() => {
    i(!1);
  }, []), m = d(() => {
    i(!1), u || n();
  }, [u, n]), g = d(() => {
    i(!1), t.logout();
  }, [t.logout]);
  return /* @__PURE__ */ a(C, { children: /* @__PURE__ */ s(
    "div",
    {
      className: `${e.menuModalOverlay} ${r ? e.menuModalOverlayOpen : ""}`,
      children: [
        /* @__PURE__ */ a(
          K,
          {
            isMenuOpen: r,
            closeMenu: b,
            openMenu: c,
            onAccountClick: m,
            handleLogout: g,
            isAuthenticated: t.isAuthenticated,
            userImage: t.userImage,
            hasNotifications: t.hasNotifications,
            language: p,
            getTranslation: l,
            isLawyerSupported: t.isLawyerSupported,
            onRequestLawyer: h,
            hideLinks: M,
            useWill: o
          }
        ),
        !M && /* @__PURE__ */ s(C, { children: [
          /* @__PURE__ */ a(
            z,
            {
              isAuthenticated: t.isAuthenticated,
              language: p,
              handleLogout: g,
              closeMenu: b,
              hasNotifications: t.hasNotifications,
              userImage: t.userImage,
              onAccountClick: m,
              getTranslation: l,
              isLawyerSupported: t.isLawyerSupported,
              onRequestLawyer: h,
              lmpEnabled: f,
              environment: t.environment,
              legalHubSupported: t.legalHubSupported
            }
          ),
          /* @__PURE__ */ a(A, { className: e.mobileBGIcon })
        ] })
      ]
    }
  ) });
}, K = (t) => {
  const {
    isMenuOpen: u,
    closeMenu: n,
    openMenu: l,
    onAccountClick: p,
    handleLogout: o,
    isAuthenticated: f,
    hasNotifications: h,
    userImage: M,
    language: r,
    getTranslation: i,
    isLawyerSupported: c,
    onRequestLawyer: b,
    hideLinks: m
  } = t, [g, N] = w(!1), L = d(() => {
    N(!0);
  }, []), k = d(() => {
    N(!1);
  }, []);
  return /* @__PURE__ */ s("div", { className: e.mobileMenuContainer, children: [
    !m && /* @__PURE__ */ a(
      "div",
      {
        className: e.menuIconContainer,
        onClick: u ? n : l,
        children: /* @__PURE__ */ s("div", { className: e.iconWrapper, children: [
          /* @__PURE__ */ a(
            "img",
            {
              src: S,
              alt: "hamburger",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.defaultIcon} ${u ? e.hidden : ""}`
            }
          ),
          /* @__PURE__ */ a(
            "img",
            {
              src: G,
              alt: "close",
              width: 24,
              height: 24,
              className: `${e.menuIcon} ${e.activeIcon} ${u ? "" : e.hidden}`
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ a(
      "a",
      {
        href: r ? `/${r}` : "/",
        className: e.logoContainer,
        children: /* @__PURE__ */ a(
          "img",
          {
            src: y,
            alt: "logo",
            width: 130,
            height: 18,
            className: e.logo
          }
        )
      }
    ),
    !m && (f ? /* @__PURE__ */ a(
      x,
      {
        isAuthenticated: f,
        userImage: M,
        openAuthModal: p,
        logout: o,
        hasNotifications: h,
        closeMenuModal: n,
        language: r,
        getTranslation: i
      }
    ) : c ? /* @__PURE__ */ s(C, { children: [
      /* @__PURE__ */ a(
        j,
        {
          label: i("pages.get-help"),
          onClick: L,
          className: e.mobileMenuGradientButton
        }
      ),
      /* @__PURE__ */ a(
        O,
        {
          language: r || "en",
          titleLabel: i("pages.get-help"),
          getTranslation: i,
          isLawyerSupported: c,
          onRequestLawyer: b,
          closeMenu: k,
          externalIsOpen: g,
          externalOnOpen: L,
          externalOnClose: k,
          hideDefaultTrigger: !0
        }
      )
    ] }) : /* @__PURE__ */ a(E, { getTranslation: i }))
  ] });
}, z = (t) => {
  const {
    handleLogout: u,
    language: n,
    closeMenu: l,
    onAccountClick: p,
    getTranslation: o,
    isLawyerSupported: f,
    lmpEnabled: h,
    onRequestLawyer: M,
    useWill: r,
    environment: i,
    legalHubSupported: c = !1
  } = t, [b, m] = w(!1), g = d(() => {
    m(!0);
  }, []), N = d(() => {
    m(!1);
  }, []), L = H(() => {
    var I;
    const k = (I = T[n]) == null ? void 0 : I.map(($) => ({
      ...$,
      path: `/${n}/${c ? "legal-hub" : "topics"}/${q($.title)}`
    }));
    return k || null;
  }, [n, c]);
  return /* @__PURE__ */ s("div", { className: e.menuModalContent, children: [
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: `${e.mainMenuLink} ${e.gradientText}`,
          onClick: g,
          children: [
            /* @__PURE__ */ a("div", { className: e.gradientTextContent, children: o("pages.get-help") }),
            /* @__PURE__ */ a(F, { className: `${e.arrowIcon}` })
          ]
        }
      ),
      /* @__PURE__ */ a(
        O,
        {
          language: n,
          titleLabel: o("pages.get-help"),
          getTranslation: o,
          isLawyerSupported: f,
          onRequestLawyer: M,
          closeMenu: N,
          externalIsOpen: b,
          externalOnOpen: g,
          externalOnClose: N,
          hideDefaultTrigger: !0
        }
      )
    ] }),
    /* @__PURE__ */ s("div", { className: `${e.menuLinksContainer} ${e.subCategories}`, children: [
      h ? /* @__PURE__ */ s("a", { href: n ? `/${n}/find` : "/find", className: e.mainMenuLink, onClick: l, children: [
        "Browse lawyers",
        /* @__PURE__ */ a(v, { className: e.arrowIcon })
      ] }) : null,
      L && /* @__PURE__ */ a(
        D,
        {
          language: n,
          titleLabel: c ? "Legal hub" : o("pages.legal-topics"),
          link: `/${n}/${c ? "legal-hub" : "topics"}`,
          items: L,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      h ? null : /* @__PURE__ */ a(
        "a",
        {
          href: `/${n}/about/company`,
          className: e.mainMenuLink,
          onClick: l,
          children: o("pages.about")
        }
      ),
      /* @__PURE__ */ a(
        W,
        {
          language: n,
          getTranslation: o,
          useWill: r,
          environment: i,
          classNames: {
            container: e.subMenuContainer,
            itemRow: e.offsetDropdownItemRow,
            mainMenuLink: e.mainMenuLink
          }
        }
      ),
      t.isAuthenticated ? /* @__PURE__ */ a(
        B,
        {
          language: n,
          handleLogout: u,
          userImage: t.userImage,
          hasNotifications: t.hasNotifications,
          getTranslation: o
        }
      ) : /* @__PURE__ */ s("div", { className: e.mainMenuLink, onClick: p, children: [
        o("pages.account"),
        /* @__PURE__ */ a(v, { className: e.arrowIcon })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: e.menuLinksContainer, children: [
      n.includes("en") && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/insights` : "/insights",
          className: e.subMenuLink,
          onClick: l,
          children: o("pages.insights")
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/faqs` : "/faqs",
          className: e.subMenuLink,
          onClick: l,
          children: o("pages.faqs")
        }
      ),
      L && /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/directory` : "/directory",
          className: e.subMenuLink,
          onClick: l,
          children: "Case study directory"
        }
      ),
      /* @__PURE__ */ a(
        "a",
        {
          href: n ? `/${n}/contact-us` : "/contact-us",
          className: e.subMenuLink,
          onClick: l,
          children: o("pages.contact-us")
        }
      )
    ] })
  ] });
};
export {
  ue as MobileMenu
};
